<template>
  <div class="live-play-box" :class='this.previewAnchorId == 0 ?"noAnchorBkg":""' @mousemove="controlShow" @mouseout="controlHide" @mouseup="VolumeBoxMoveFun(false)">
      <!-- <VideoGiftPlayer ref="videogift" v-show="bShowVideoGift" style="position: absolute; width:100%; height:100%; z-index:1" @playState="onPlayState"></VideoGiftPlayer> -->
      <button class="joinRoom" v-show="this.bShowEnter && control && this.previewAnchorId != 0" @click="onCilckEnterRoom">进入直播间</button>
      <div class="liver-bg-box">
          <div class="liver-bg-box-mask"></div>
          <img :src="anchorHead" alt="" width="100%" :height="bShowEnter?'100%':''">
      </div>
      <div class="live-play-con" 
            :class="bConnect?'liveVideoConnect':'' + !this.bLiveEnd && this.videoUrl != ''?'':' liveVideoUndispaly'">
        <video-player
            class="video-player vjs-custom-skin"
            :options="playerOptions"
            ref="videoPlayer"
            @error="onError($event)"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @statechanged="onPlayerStateChanged($event)"
            ></video-player>
      </div>
      <transition name="slide-fade-controlbar">
        <div class="live-play-controls" v-show="control&&!this.bLiveEnd && this.videoUrl != ''">
            <div @click="changePlayStatus" class="iconfont iconColor" :class="playPause?'iconbofang':'iconzanting'"></div>
            <div class="iconfont iconColor" :class="volumeNum==0||bMute?'iconjingyin':'iconyinliang'" @click.self="changeMuteStatus">
              <transition name="fade">
                <div class="volumeBox" >
                  <div class="volumeCon" @mousemove="volumeNumChange" ref='volumeCon'>
                    <div class="volumeNum" @mousedown="VolumeBoxMoveFun(true)" :style="{height:volumeNum+'px'}"></div>
                  </div>
                </div>
              </transition>
            </div>
        </div>
      </transition>
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'

import VideoGiftPlayer from "@/components/VideoGiftPlayer";
import crypt from '@/js/utils/crypt.js';
require('videojs-flash/dist/videojs-flash')
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import jsonpAdapter from 'axios-jsonp'
import { setTimeout, clearInterval } from 'timers';
export default {
  name: "livePlayBox",
  props:{
    previewAnchorId:{
      type:Number,
      default:0
    },
    bShowEnter:{
      type:Boolean,
      default:false
    },
    bEnd:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      isFull:false,
      VolumeShowBool:false,
      VolumeCanMove:false,
      mouseY:0,
      errortimes:0,
      volumeNum:50,
      lastVol:50,
      playPause:false,
      control:false,
      playerOptions: {
        controls: false,
        width:"900px",
        techOrder: ['flash', 'html5'],
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "application/x-mpegURL",
            src:"" //你的m3u8地址（必填）
          }
        ],
        //poster:"https://img.live.sinashow.com/pic/avatar/895157206_32007_720*720.jpg", //你的封面地址
        //width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        // controlBar: {
        //   timeDivider: false,
        //   durationDisplay: false,
        //   remainingTimeDisplay: false,
        //   fullscreenToggle: true //全屏按钮
        // },
      },
      bplaying:false,
      bwaiting:false,
      strVideoUrl:"",
      bConnectState:false,
      timeHandle:null,
      bMute:this.$store.state.loginUserInfo.pid == '167' && this.bShowEnter,
      bShowVideoGift:false,
    };
  },
  mounted() {
      // this.player.height('1060px')
      this.getAnchorInfo(this.anchorID);
      this.volumeVideoChange(false);

  },
  watch:{
    anchorID(newValue, oldValue){
      this.getAnchorInfo(newValue);
      this.volumeVideoChange(false);
    }
  },
  components: {videoPlayer, VideoGiftPlayer },
  methods: {
    controlShow(){
      this.control=true;
    },
    controlHide(){
      this.control=false;
    },
    onPlayerPlay(player) {
      this.playPause=false;
    },
    onPlayerPause(player) {
      this.playPause=true;
    },
    onPlayerStateChanged (playerCurrentState) {
      if(this.bLiveEnd){
        return
      }
      if(playerCurrentState.timeupdate){
        return
      }
      if (!this.bplaying && playerCurrentState.playing) {
        if (this.timeHandle != null) {
           clearTimeout(this.timeHandle);
           this.timeHandle = null;
        }
        this.bplaying = playerCurrentState.playing;
        this.bwaiting = false;
        if (!this.bMute) {
          console.log('unmuted in onPlayerStateChanged')
          this.player.muted(false);
        }
      }

      if (this.bplaying && playerCurrentState.waiting) {
        this.bwaiting = playerCurrentState.waiting;
      }

      if (this.bplaying && this.bwaiting) {
        this.bplaying = false;
        let that = this;
        if(this.timeHandle!=null){
          clearTimeout(this.timeHandle);
        }
        this.timeHandle = setTimeout(function () {
          if (that.bwaiting) {
            that.player.src([{ type: "application/x-mpegURL", src: that.strVideoUrl }]);
            that.player.play();
            clearTimeout(that.timeHandle);
            that.timeHandle = null;
            that.bwaiting = false;
            that.$emit("playend");
          }
        }, 10000);
      }
    },
    changePlayStatus(){
      if(!this.playPause){
        this.player.pause();
      }else{
        this.player.play();
      }
    },
    changeMuteStatus(){
        this.bMute = !this.bMute;
        this.player.muted(this.bMute);
    },
    stopLive() {
      let currentAnchorInfo = this.$store.state.chatRoomInfo.currentAnchorInfo
      if (currentAnchorInfo) {
        let url = '';
        if (currentAnchorInfo.micstate == 3 || currentAnchorInfo.micstate == 2) {
          url = currentAnchorInfo.micUrl;
        } else {
          url = currentAnchorInfo.url;
        }
        this.player.src([{ type: "application/x-mpegURL", src: url }]);
        // document.getElementsByTagName('video')[0].src = url;
        // document.getElementsByTagName('video')[0].preload = 'auto';
        this.player.play();
        this.volumeVideoChange(false);
      }
    },
    onError(player) {
      if(this.errortimes>2){
        return
      }else{
        this.errortimes++;
      }
      this.player.src([{ type: "application/x-mpegURL", src: this.strVideoUrl }]);
      this.player.play();
      return;
    },
    fullWindow(){
      this.player.requestFullscreen()
    },
    VolumeBoxShowHide(){
      this.VolumeShowBool=!this.VolumeShowBool
    },
    volumeNumChange(e){
      if(!this.VolumeCanMove){
        return
      }
      let num=this.mouseY-event.pageY;
      if(num>100){
        num=100
      }else if(num<0){
        num=0
      }
      this.volumeNum=num;
      this.volumeVideoChange(true)
    },
    VolumeBoxMoveFun(bool){
      this.VolumeCanMove=bool;
      if(this.VolumeCanMove){
        this.mouseY=event.pageY+this.volumeNum
      }
    },
    volumeVideoChange(bSwitchMute){
      if (bSwitchMute) {
        this.bMute = false;
        this.player.muted(false);
      }
      this.player.volume(this.volumeNum/100);
    },
    switchUrl(iType, url){//2, 3 为连麦
      this.bConnectState = false;
      let currentUrl = "";
      if (url) {
        if (url.indexOf('hdlws.sinashow.com') > 0) {
            //var state = 0;
            //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
           currentUrl = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
            //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
            currentUrl = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        } else {
            //var state = 1;
            //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
            currentUrl = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
        }
      }
      if ((iType == 2 || iType ==  3) && currentUrl !== "") {
        this.player.src([{ type: "application/x-mpegURL", src: currentUrl }]);
        this.strVideoUrl=currentUrl;
        // document.getElementsByTagName('video')[0].src = currentUrl;
      } else {
        let selfUrl = this.$store.state.chatRoomInfo.currentAnchorInfo.url;
        this.player.src([{ type: "application/x-mpegURL", src: selfUrl }]);
        this.strVideoUrl=selfUrl;
        // document.getElementsByTagName('video')[0].src = selfUrl;
      }
      // document.getElementsByTagName('video')[0].preload = 'auto';
      this.player.play();
    },
    getAnchorInfo(iAnchorId){
      if (iAnchorId <= 0) {
        return;
      }
      let data = {
        anchorid:iAnchorId,
      }
      let that = this;
      this.axios({
        url:"https://external.fengbolive.com/cgi-bin/get_anchor_info_proxy.fcgi?"+this.$common.changeobj(data),
        adapter: jsonpAdapter,
        callbackParamName: 'jsoncallback', // optional, 'callback' by default
      }).then(res=>{
        let data = res.data;
        if (data.code > 0 || data.ret > 0) {
          let encryptedInfo = data.info;
          let info = crypt.decrypt(encryptedInfo);
          let objInfo = JSON.parse(info);
          if (objInfo.url) {
            let fid = 0;
            if (objInfo.familyid) {
              fid = objInfo.familyid;
            }
            localStorage.setItem('FamilyId','' + fid);
            sessionStorage.setItem('currentAnchorInfo', info);
            that.$store.commit('ROOMINFO_CURRENT_ANCHOR_INFO', objInfo);
            that.$store.commit('ROOMINFO_CURRENT_ANCHOR_ID', objInfo.id);
            let currentAnchorInfo = that.$store.state.chatRoomInfo.currentAnchorInfo
            if (currentAnchorInfo.url) {
              let url = '';
              if (currentAnchorInfo.micType == 1) {
                if(this.bShowEnter){
                  this.bConnectState = true;
                }else{
                  this.bConnectState = false;
                }
                url = currentAnchorInfo.micUrl;
              } else {
                this.bConnectState = false;
                url = currentAnchorInfo.url;
              }
              that.strVideoUrl = url;
              that.bplaying = false;
              that.bwaiting = false;
              that.player.src([{ type: "application/x-mpegURL", src: url }]);
              // document.getElementsByTagName('video')[0].src = url;
              // document.getElementsByTagName('video')[0].preload = 'auto';
              that.player.play();
            }
          }else{
            that.bEnd = true;
            that.$store.commit('ROOMINFO_CURRENT_ANCHOR_INFO', null)
            that.$store.commit('ROOMINFO_CURRENT_ANCHOR_ID', 0);
            sessionStorage.setItem('currentAnchorInfo', '');
            localStorage.setItem('FamilyId','0');
          }
        }else if (data.code == 0 || data.ret == 0){
          that.$store.commit('ROOMINFO_CURRENT_ANCHOR_INFO', null)
          that.$store.commit('ROOMINFO_CURRENT_ANCHOR_ID', 0);
          sessionStorage.setItem('currentAnchorInfo', '');
          localStorage.setItem('FamilyId','0');
        }
        that.$emit("getAnchorInfoFinishi");
      }).catch();
    },
    onCilckEnterRoom(){
      let strPath = "/live/" + this.anchorID;
      let param = { path: strPath };
      this.$router.push(param);
    },
    
    playVideoGift(url){
      this.bShowVideoGift = true;
      //this.$refs.videogift.addPalyTask(url);
    },
    onPlayState(iState){
      if (iState == 0) {
        this.bShowVideoGift = false;
      }
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    anchorHead(){
      let AnchorInfo = this.$store.state.chatRoomInfo.currentAnchorInfo
      if (AnchorInfo) {
        let t = 'https://img.fengbolive.com/pic/avatar/{0}_{1}_720*720.jpg';
        let strHeadUrl = '';
        if (AnchorInfo.phid == 0) {
            strHeadUrl = "http://img.fengbolive.com/pic/avatar/default.png";
        } else if(AnchorInfo.phid == 1){
            strHeadUrl = "http://img.fengbolive.com/pic/avatar/smallHeadForAuthFail.png";
        } else {
            strHeadUrl = t.format(this.previewAnchorId, AnchorInfo.phid);
        }
        return strHeadUrl;
      }else{
        return null;
      }
    },
    videoUrl(){
      return this.strVideoUrl;
    },
    anchorID(){
      return this.previewAnchorId;
    },
    bLiveEnd(){
      return this.bEnd;
    },
    bConnect(){
      return this.bConnectState;
    }
  }
};
</script>
<style>
.live-play-box{width: 100%; height: 100%; position: relative;overflow: hidden;}
.live-play-box.noAnchorBkg{ background-image: url("~@/assets/images/noAnchor_bkg.png"); filter:"progid:DXImageTransform.Microsoft.AlphaImageLoader(sizingMethod='scale')"; background-size: 100% 100%;}
.joinRoom{width:148px;height:40px;line-height: 40px;position: absolute;top:50%;left:50%;margin-left: -73px;margin-top:-35px;z-index:3;background:transparent;color:#fff; border-color: #fff;border-radius: 20px;font-size:18px;border-style: solid; border-width: 2px;}
.joinRoom:hover{border-color: #8d5feb; color:#8d5feb} 
.live-play-con{position: relative;height: 100%;}
.liveVideoUndispaly{ display: none;}
.liveVideoConnect{ height: 345px; top:41px;}
.liver-bg-box{ width: 100%; height: 100%; position: absolute; overflow: hidden; filter: blur(7px);}
.liver-bg-box-mask{ position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.4)}
.live-play-con .video-player{ height: 100%;}
.live-play-box .vjs-error-display,.live-play-box .vjs-big-play-button{ display: none!important}
.live-play-box .vjs-poster{ background-size: cover}
.live-play-box .video-js{ background: transparent!important;}
.live-play-box .vjs-custom-skin > .video-js{ padding: 0; height: 100%;}
.live-play-box  .video-js .vjs-tech{ object-fit: cover; width: auto; left: 50%; transform: translateX(-50%);}
.index-Play-box{ position: absolute; left: 0;top: 0; width: 100%; height: 100%; z-index: 99}
.live-play-controls{z-index: 11; height: 40px; width: 100%; background: rgba(0, 0, 0, .3); position: absolute; left: 0;bottom: 0; display: flex; justify-content:flex-start; align-items: center; padding: 0 25px; box-sizing: border-box;}
.iconColor{color: #ffffff; margin-right: 20px; cursor: pointer;position: relative; height: 100%; display: flex; align-items: center; width: 17px}
.iconbofang,.iconzanting{ flex: 1}
.iconjingyin,.iconyinliang{ flex: none;margin-right: 0px;}
.iconjingyin:hover .volumeBox,.iconyinliang:hover .volumeBox{ flex: none;margin-right: 0px;}
.volumeBox{background: url(~@/assets/images/volumeBg.png); width: 48px; height: 138px; position: absolute; top:-135px; left: -17px; display: none; justify-content: center; align-items: center; cursor: initial}
.iconjingyin:hover .volumeBox,.iconyinliang:hover .volumeBox{ display:flex}
.volumeCon{ height: 100px; width: 4px; background: #fff; margin-top: -5px; border-radius: 3px; position: relative;}
.volumeNum{ width: 100%; height: 20px; background: #7c46e8; position: absolute; bottom: 0}
.volumeNum::after{ content: ""; position: absolute; background: url(~@/assets/images/voiceH.png); width: 16px; height: 16px; left: 50%; top: -8px; margin-left: -8px; cursor: pointer;}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-fade-controlbar-enter-active {
  transition: all .3s ease;
}
.slide-fade-controlbar-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-controlbar-enter, .slide-fade-controlbar-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
